module.exports = __webpack_public_path__ + "vue_assets/img/img_assetpack_elven.fd6d95ae.jpg";